export enum DiscoverRoutePathNames {
  DISCOVER = 'discover',
  LIST = '',
}
